import { RadioButton } from '../RadioButton';
import { Group } from './RadioGroup.styles';
import type { RadioGroupProps } from './RadioGroup.types';

export function RadioGroup({ name, options, value, onChange, direction = 'row' }: RadioGroupProps) {
  return (
    <Group role="radiogroup" $direction={direction}>
      {options.map((option) => (
        <RadioButton
          key={option.value}
          name={name}
          value={option.value}
          label={option.label}
          checked={value === option.value}
          onChange={onChange}
          disabled={option.disabled}
        />
      ))}
    </Group>
  );
}
